import React from 'react';

import { TVendorsValues } from '@enums/common';

import styles from './UnavailableFeatureMessage.module.scss';

interface Props {
	vendorName?: TVendorsValues;
}

const UnavailableFeatureMessage: React.FC<Props> = ({ vendorName }) => {
	return (
		<div className={styles.unavailableFeature}>
			This page doesn’t support the {vendorName ?? 'selected'} vendor. Please choose a different vendor or navigate to another page.
		</div>
	);
};

export default UnavailableFeatureMessage;
